import React, { Component } from "react";
import SalesUploadBody from "./SalesUploadBody";
import SalesRegisterBody from "./SalesRegisterBody";
import VehiclesNrUploadsBody from "./VehiclesNrUploadsBody";

class VehiclesNrUploads extends Component {
  render() {
    return (
      <div className="animated fadeIn">
        <VehiclesNrUploadsBody />
      </div>
    );
  }
}

export default VehiclesNrUploads;



// WEBPACK FOOTER //
// ./src/components/CustomComponents/VehiclesNrUploads.js